import { NgModule } from '@angular/core';
import { BgImageComponent } from './bg-image.component';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatRadioModule } from '@angular/material/radio';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MiqSecuredResourcesModule } from '../miq-secure-resources/miq-secured-resources.module';
import { AddAdditionalImageDialogComponent } from './add-additional-image-dialog/add-additional-image-dialog';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  imports: [
    CommonModule,
    MatIconModule,
    MatTooltipModule,
    MiqSecuredResourcesModule,
    MatButtonModule,
    MatDialogModule,
    MatFormFieldModule,
    MatRadioModule,
    FormsModule,
    ReactiveFormsModule.withConfig({
      callSetDisabledState: 'whenDisabledForLegacyCode',
    }),
    MatCheckboxModule,
  ],
  exports: [BgImageComponent, AddAdditionalImageDialogComponent],
  declarations: [BgImageComponent, AddAdditionalImageDialogComponent],
})
export class MiqImagesModule {}
